module.exports = __webpack_public_path__ + "img/australia-lung-cancer-male.2e38c18c.png";